import { API_URL } from "utils/environmentVariables";

interface props {
  path: string;
}
export default function ({ path }: props) {
  return `${API_URL}${path}`;
}
